import { useBenefitGateCore } from "../../core/useBenefitsCore";
import { EShowMode } from "../../enums/benefits.enums";
import { canInjectDisabled, OverlayGateProps } from "../utils";
import { DisabledCloneWrap, OverlayWrap, TooltipWrap } from "../wrappers/BenefitWrapper";

// Botón MUI (inyecta disabled automáticamente + tooltip):
// <BenefitDisableGate
//   benefit={EBenefitTypes.AREASCOVERAGES}
//   blockedTooltip="Upgrade required to add more coverage areas"
// >
//   <Button variant="contained" onClick={onAddArea}>
//     Add Coverage Area
//   </Button>
// </BenefitDisableGate>
// IconButton MUI:
// <BenefitDisableGate
//   benefit={EBenefitTypes.FINDACLEANER}
//   blockedTooltip={({ reason }) => (reason === "LIMIT_REACHED" ? "Limit reached" : "Not available")}
// >
//   <IconButton onClick={onClickSearch}>
//     <SearchIcon />
//   </IconButton>
// </BenefitDisableGate>
//
// Fallback overlay (si el child no soporta disabled):
// <BenefitDisableGate
//   benefit={EBenefitTypes.METRICS_BASIC}
//   blockedTooltip="Upgrade to access"
//   overlayLabel="Locked"
// >
//   <SomeCustomWidget />
// </BenefitDisableGate>

export function BenefitDisableGate(props: OverlayGateProps) {
    const {
        benefit,
        showWhenBlocked = EShowMode.DISABLED,
        blockedTooltip,
        overlayLabel,
        overlay = true,
        overlaySx,
        sx,
        children,
    } = props;

    const core = useBenefitGateCore(benefit, { showWhenBlocked, blockedTooltip, overlayLabel });

    if (core.decision.mode === EShowMode.NULL) return null;

    if (typeof children === "function") {
        return (
            <TooltipWrap enabled={core.tooltipEnabled} title={core.tooltipTitle} display="inline-flex" sx={sx}>
                {children(core.args)}
            </TooltipWrap>
        );
    }

    if (!core.disabled) return children;

    if (canInjectDisabled(children)) {
        return (
            <TooltipWrap enabled={core.tooltipEnabled} title={core.tooltipTitle} display="inline-flex" sx={sx}>
                <DisabledCloneWrap child={children} sx={sx} />
            </TooltipWrap>
        );
    }

    return (
        <TooltipWrap enabled={core.tooltipEnabled} title={core.tooltipTitle} display="block" sx={sx}>
            <OverlayWrap overlay={overlay} label={core.label} sx={sx} overlaySx={overlaySx}>
                {children}
            </OverlayWrap>
        </TooltipWrap>
    );
}
